<template>
  <section id="GroupSeating">
    <div id="GroupSeating-selector"></div>
    <div class="overlay"></div>
    <b-container>
      <div class="title">
        <div class="bold">General</div>
        Group Seating
      </div>
      <div class="divider" />
      <div class="area-description">
        Sit your group together for a night of fun and entertainment in a
        variety of sections throughout Globe&nbsp;Life&nbsp;Field.
      </div>
      <a v-scroll-to="{ el: '#BookSuite', offset: -80 }" class="book-now"
        >Book Now</a
      >
      <SelectSeatingArea
        :seatingData="seatingData"
        :seatingSection="'group'"
        v-if="windowWidth > 992"
      />
      <SelectSeatingAreaMobile
        :seatingData="seatingData"
        :seatingSection="'group'"
        v-else
      />
    </b-container>
  </section>
</template>

<script>
import SelectSeatingArea from "@/components/global/SelectSeatingArea";
import SelectSeatingAreaMobile from "@/components/global/SelectSeatingAreaMobile";
import { groupSeatingData } from "@/data/groupSeating.js";

export default {
  name: "GroupSeating",
  components: {
    SelectSeatingArea,
    SelectSeatingAreaMobile,
  },
  data() {
    return {
      seatingData: groupSeatingData(),
      windowWidth: null,
    };
  },
  mounted() {
    this.windowWidth = window.innerWidth;

    window.addEventListener(
      "resize",
      () => {
        this.windowWidth = window.innerWidth;
      },
      false
    );
  },
};
</script>

<style lang="scss" scoped>
#GroupSeating {
  position: relative;
  // background-image: url("~@/assets/images/backgrounds/bg_general-group-seating-3.jpeg");
  background-image: url("~@/assets/images/backgrounds/groups-lockout-general-group-seating.jpeg");
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  margin-top: 25px;
  padding: 90px 0 140px 0;
  @media (max-width: $lg) {
    background-image: url("~@/assets/images/backgrounds/mobile-bg.jpg");
    background-position: bottom;
    padding: 70px 0;
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(
      270deg,
      rgba(4, 12, 24, 0) 0%,
      rgba(4, 12, 24, 0.9) 100%
    );
    @media (max-width: $lg) {
      background-color: rgba(4, 12, 24, 0.8);
    }
  }
  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
  }
  .title {
    display: flex;
    flex-direction: column;
    font-family: BertholdCondensed;
    font-size: 40px;
    line-height: 32px;
    letter-spacing: 0;
    text-transform: uppercase;
    color: #ffffff;
    .bold {
      font-weight: 700;
    }
  }
  .divider {
    height: 2px;
    width: 70px;
    background-color: #ffffff;
    margin: 10px 0 24px 0;
  }
  .area-description {
    font-family: Gotham;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;
    color: #ffffff;
    max-width: 393px;
  }
  .book-now {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Gotham;
    font-weight: 900;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0;
    color: #ffffff;
    text-transform: uppercase;
    text-decoration: none;
    width: 120px;
    height: 40px;
    border-radius: 8px;
    background-color: #c10230;
    margin: 24px 0 50px 0;
    cursor: pointer;
  }
}
</style>
